import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ClippyContentWrapper"
}
const _hoisted_2 = { class: "ClippyTextbox" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "ClippyJokeButtons" }
const _hoisted_5 = {
  id: "FunnyJoke",
  class: "JokeButton"
}
const _hoisted_6 = {
  id: "NotFunnyJoke",
  class: "JokeButton"
}
const _hoisted_7 = {
  id: "DismissClippyForever",
  class: "JokeButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
		'ClippyWidget',
		_ctx.clippyRight ? 'ClippyRight' : 'ClippyLeft',
		_ctx.clippyHideFunny ? 'ClippyHidden' : 'ClippyVisible'
	])
  }, [
    (_ctx.clippyShouldBeVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "ClippyJokeText",
              innerHTML: _ctx.currentJoke
            }, null, 8 /* PROPS */, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.funny && _ctx.funny(...args)))
                }, "Funny")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.notFunny && _ctx.notFunny(...args)))
                }, "Not Funny")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideClippy && _ctx.hideClippy(...args)))
                }, "Hide")
              ])
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "ClippyImageContainer" }, [
            _createElementVNode("img", {
              class: "ClippyImage",
              src: "https://monet-prtl-co.imgix.net/Endor/Easteregg/clippy.png",
              alt: "Loading ..."
            })
          ], -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}